import { Component, OnInit, ViewChild } from '@angular/core';
import { ModelService } from '../services/model.service';
import { LoginService } from '../login/login_service/login.service';
import { Router } from '@angular/router';
import { UserListService } from '../admin/user-list/user-list.service';
import { ProjectData } from '../entities/project-data.entity';
import { Utils } from '../utils.module';

import { Store } from '@ngrx/store';
import * as actionsPath from '../store/path/path.actions';
import * as actionsHistory from '../store/history/history.actions';

import { AppState } from '../app.reducers';
import { ProjectListService } from '../admin/project-list/project-list.service';
import { PropagarService } from '../services/propagar.service';
import { UserDetailService } from '../admin/user-detail/user-detail.service';
import { User } from '../entities/user.entity';
import { BearerHttpService } from '../services/bearer-http.service';
import { ParseProjectVersion } from '../utils/parse-project-version';
import { AlertData } from '../alert/alert-data.entity';
import { ConfigService } from '../app.config';
import { map } from 'rxjs/operators';
import { LanguageService } from '../services/language.service';


@Component({
	selector: 'app-hold',
	templateUrl: './hold.component.html',
	styleUrls: ['./hold.component.scss']
})
export class HoldComponent implements OnInit {

	@ViewChild('alertWindow', { static: false }) alertWindow: any;

	public nombreProyecto = "";
	public errorProyecto = false;
	public projectData: ProjectData;

	constructor(
		private store: Store<AppState>,
		public modelService: ModelService,
		private loginService: LoginService,
		private userListService: UserListService,
		public projectListService: ProjectListService,
		private userProfileService: UserDetailService,
		public router: Router,
		private http: BearerHttpService,
		private languageService: LanguageService,
	) {

	}

	public listLastProjects = [];

	ngOnInit(): void {
 		//localStorage.setItem("language", "es");

		this.store.subscribe(state => {
			this.listLastProjects = state.holdHistory;
			//this.modelService.getUser().getData().lastProjects = state.holdHistory;
		});

		// Leer los datos del historial de últimos proyectos.
		this.userProfileService.getUser2(this.modelService.getUser().getData().id).subscribe((result) => {
			const userData: User = result.result;
			if (userData && userData.lastProjects) {
				this.store.dispatch(actionsHistory.update({ lastProjects: userData.lastProjects }));
			}
			else {
				this.store.dispatch(actionsHistory.update({ lastProjects: this.modelService.getUser().getData().lastProjects }));
			}
		});

	}

	public testeo(texto: string) {
		console.log(texto);
	}

	public newProject(scheme: boolean): void {
		let _nombre = this.nombreProyecto.trim();
		if (_nombre.length === 0) {
			// Motrar error.
			this.errorProyecto = true;
			let dom = document.getElementById('nombreProyectoFocus');
			if (dom) dom.focus();
			return;
		}

		this.errorProyecto = false;

		this.projectData = new ProjectData();
		this.projectData.fechaCreacion = new Date(); // ? ya viene con fecha
		this.projectData.nombre = _nombre;
		this.projectData.renderer = (scheme) ? Utils.SCHEME2 : Utils.SATELITE;

		this.nombreProyecto = "";

		//Utils.NAV_Reset();
		this.store.dispatch(actionsPath.home());

		this.projectData.userId = this.modelService.getUser().getData().id;
		this.projectData.idioma = this.modelService.getLanguage().currentLanguage;
		this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;

		let parse = new ParseProjectVersion();
		this.projectData.valoresCentrado = parse.computeCenter(this.projectData);

		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

		// Avisar que no viene del 3D.
		this.store.dispatch(actionsPath.iDontComingFrom3D());

		if (scheme) {
			this.router.navigate(['/scheme']);
			//setTimeout(() => { Propagar Service.get('G ProjectLoadScheme').emit('All right!'); }, 200);
			setTimeout(() => { this.modelService.GProjectLoadScheme.emit('All right!'); }, 200);
		}
		else {
			this.router.navigate(['/satelite']);
			setTimeout(() => { PropagarService.get('GProjectLoadSatelite').emit('All right!'); }, 200);
		}
	}

	public logout(): void {
		this.loginService.logout();
		const idioma = localStorage.getItem('language') || 'es';
		localStorage.clear();
		localStorage.setItem('language', idioma);
		this.router.navigate(['/login']);
	}

	public goto(andNavigateTo?: string): void {
		// TODO ORDENAR
		if (andNavigateTo) {
			this.nombreProyecto = "";
			this.errorProyecto = false;
			// Siempre que sale del HOLD limpia el historial.
			this.store.dispatch(actionsPath.home());
			this.router.navigate([andNavigateTo]);
		}
	}

	// Funcion que modifica el idioma, le pasamos el idioma y cambia de idioma automáticamente a través de setLanguage y después, le pasamos
	// el servicio del userProfileService del servicio UserDetailService, le pasamos dos parámetros, el idioma y después, tenemos que recuperar el ID del usuario para poder
	//acceder a la bbdd, en toda la app se utiliza para acceder : this.modelService.getUser().getData()) -> vamos al servicio de user-detail.service.ts
	//creamos la función updateLanguage y le pasamos las rutas

	public updateLanguage(idioma:string){
		this.modelService.getLanguage().setLanguage(idioma);
		this.userProfileService.updateLanguage(idioma,this.modelService.getUser().getData());
	}

	public openProject(id: string, title: string) {
		this.nombreProyecto = "";
		this.errorProyecto = false;
		console.log(`openProject(id: ${id}, title: ${title})`);

		// Obtener el proyecto de MongoDB.
		this.projectListService.getProject(id).subscribe((project: ProjectData) => {
			// Proyecto vacío.
			if (project === null) {
				// Si no existe avisar y quitar del historial.
				const _his = this.userListService.historyCleanProject(id, this.modelService.getUser().getData())
					.subscribe(() => {
						this.mensaje(this.modelService.getString('hold_alert_deleteTitle'),
							this.modelService.getString('hold_alert_deleteBody').replace('{DATA}', title));
						_his.unsubscribe();
					});
				return;
			}

			// Añadir actual proyecto al historial del usuario.
			const _his = this.userListService.historyProjects(id, title, project.renderer, this.modelService.getUser().getData())
				.subscribe(() => { _his.unsubscribe(); });

			// Versionador de proyectos.
			let newVersion = new ParseProjectVersion();
			project = newVersion.parse(project);
			//console.log('OPEN PROYECT >>>>>>>>>>>>>>>>>>>');

			// Avisar que no viene del 3D.
			this.store.dispatch(actionsPath.iDontComingFrom3D());

			this.store.dispatch(actionsPath.home());

			if (project.renderer === Utils.SATELITE) {
				this.router.navigate(['/satelite']);
				setTimeout(() => { PropagarService.get('GProjectLoadSatelite').emit('All right!'); }, 100);
			}
			else {
				this.router.navigate(['/scheme']);
				//setTimeout(() => { Propagar Service.get('G ProjectLoadScheme').emit('All right!'); }, 100);
				setTimeout(() => { this.modelService.GProjectLoadScheme.emit('All right!'); }, 100);
			}
		});
	}

	private mensaje(titulo: string, texto: string) {
		const data: AlertData = new AlertData();
		data.title = titulo;
		data.message = texto;
		this.alertWindow.show(data);
	}

}
